import { render, staticRenderFns } from "./deductionList.vue?vue&type=template&id=9584102e&scoped=true&"
import script from "./deductionList.vue?vue&type=script&lang=js&"
export * from "./deductionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9584102e",
  null
  
)

export default component.exports